function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function yearStart(year) {
  return new Date(year, 0, 1);
}

function yearEnd(year) {
  return new Date(year, 11, 31);
}

function normalizeScopeStartDate(scopedYear, scopeStartDate, effectiveEndDate) {
  if (!(scopeStartDate instanceof Date) || Number.isNaN(scopeStartDate.getTime())) {
    return yearStart(scopedYear);
  }

  if (scopeStartDate.getFullYear() !== scopedYear || scopeStartDate.getTime() > effectiveEndDate.getTime()) {
    return yearStart(scopedYear);
  }

  return new Date(scopedYear, scopeStartDate.getMonth(), 1);
}

export function createScopeDateContext(scopeYear, now = new Date(), options = {}) {
  const parsedYear = Number(scopeYear);
  const currentYear = now.getFullYear();
  const scopedYear = Number.isInteger(parsedYear) ? parsedYear : currentYear;
  const currentMonthIndex = now.getMonth();
  const currentDate = now.getDate();
  const daysInScopedYear = isLeapYear(scopedYear) ? 366 : 365;
  const isCurrentYear = scopedYear === currentYear;
  const end = isCurrentYear ? now : yearEnd(scopedYear);
  const start = normalizeScopeStartDate(scopedYear, options.scopeStartDate, end);

  if (!isCurrentYear) {
    return {
      scopedYear,
      isCurrentYear,
      currentMonthIndex,
      currentDate,
      daysInYear: daysInScopedYear,
      elapsedDays: Math.max(
        Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1,
        1
      ),
      elapsedMonths: (end.getMonth() - start.getMonth()) + 1,
      remainingDays: 0
    };
  }
  const yearFinish = yearEnd(scopedYear);

  return {
    scopedYear,
    isCurrentYear,
    currentMonthIndex,
    currentDate,
    daysInYear: daysInScopedYear,
    elapsedDays: Math.max(
      Math.floor((now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1,
      1
    ),
    elapsedMonths: (now.getMonth() - start.getMonth()) + 1,
    remainingDays: Math.max(
      Math.ceil((yearFinish.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)),
      1
    )
  };
}

export function normalizeScopeDateContext(input) {
  if (input && typeof input === "object" && typeof input.elapsedDays === "number") {
    return input;
  }

  if (input instanceof Date) {
    return createScopeDateContext(input.getFullYear(), input);
  }

  return createScopeDateContext(undefined, new Date());
}
